import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { folderTypes } from "@redotech/redo-views-common/folders";
import { WarrantyView } from "@redotech/redo-views-common/views";
import { ReactNode, createContext, memo } from "react";
import { useRecordViews } from "../../return/views/record-views-query";

export const WarrantyViewsContext = createContext<
  | {
      teamViews?: WarrantyView[];
      folders?: folderTypes["warranties"][];
      reloadViews?: () => Promise<void>;
    }
  | undefined
>(undefined);

export const ReloadWarrantyViewsContext = createContext<
  (() => Promise<void>) | undefined
>(undefined);

export const WarrantyViewsProvider = memo(function WarrantyViewsProvider({
  children,
}: {
  children: ReactNode | ReactNode[];
}) {
  const { views, folders, reloadViews } = useRecordViews(
    ReturnTypeEnum.WARRANTY,
    ReturnsAndClaimsPermissions.MANAGE_WARRANTY,
  );

  return (
    <WarrantyViewsContext.Provider
      value={{ teamViews: views, folders, reloadViews }}
    >
      <ReloadWarrantyViewsContext.Provider value={reloadViews}>
        {children}
      </ReloadWarrantyViewsContext.Provider>
    </WarrantyViewsContext.Provider>
  );
});
